import Client from "../AxiosClient";
const resource = "/private/accounts";

export default {
  /**
   * Lấy thông tin chi tiết của một tài khoản.
   * @param {} username
   * @returns
   */
  async get(username) {
    try {
      const userinfo = await Client.get(`${resource}/${username}`);
      return userinfo.data.data[0];
    } catch (error) {
      return { error: error };
    }
  },

  async update(userInfo) {
    try {
      const response = await Client.put(`${resource}`, userInfo);
      return response;
    } catch (error) {
      return {
        error: error,
      };
    }
  },

  async get_list_account(params) {
    try {
      const response = await Client.get(
        `${resource}/get_account?id=${params.id}&account=${params.account}&department_id=${params.department_id}`
      );
      return response;
    } catch (error) {
      return {
        error: error,
      };
    }
  },

  async get_role_user() {
    try {
      const response = await Client.get(`${resource}/get_role_user`);
      return response.data;
    } catch (error) {
      return {
        error: error,
      };
    }
  },

  async lock_account(body) {
    try {
      const response = await Client.post(`${resource}/lock_account`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async reset_password(body) {
    try {
      const response = await Client.post(`${resource}/reset_password`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async create_account(body) {
    try {
      const response = await Client.post(`${resource}/create_account`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async update_avatar(body) {
    try {
      const response = await Client.post(`${resource}/update_avatar`, body);
      console.log(body);
      console.log(response);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
};
